<div class="col-md-1 col-sm-3" class="rightBox">
    <div class="rightBox1" *ngIf='currentUrl!=="/locked/product-language"'>
      <strong>Toolkit WSDL is here!</strong>
      <p>Toolkit transactions are now available as WSDL’s , further easing integration of D&B’s global data
        into your applications. For more information, contact Toolkit Tech Support or click on the GO.</p>
       <a aria-label="Link to Product data sheet" target="_blank" [routerLink]="['/locked/td-product-data-sheet-hyperlinks',{page:'productSpecification'}]">
      <button aria-label="Product Specification" tabindex=0 role=button class="btn-sm btn-primary rightBoxButton">Go</button></a>
    </div>
    <div class="clearfix rightBoxGap"></div>
    <div class="rightBox2">
      <strong>Company Search</strong>
      <p>Search for companies using their company name and address, individual name, D-U-N-S® Number, phone
        number, or business I.D.</p>
       <a aria-label="Link to Company search" target="_blank" [routerLink]="'/locked/company-search'">
      <button aria-label="Company search" tabindex=0 role=button class="btn-sm btn-primary rightBoxButton" >Go</button></a>
    </div>
    <div class="clearfix rightBoxGap"></div>
    <div class="rightBox2">
      <strong>Toolkit Platform transition</strong>
      <p>We've been transitioning to a new Data Integration Toolkit platform. Click here to see the latest
        schedule and the Release Notes.</p>
        <a aria-label="Link to release update" target="_blank" [routerLink]="'/unlocked/release-update'"><button aria-label="Link to release update" tabindex=0 role=link class="btn-sm btn-primary rightBoxButton">Go</button></a>

    </div>
    <div class="clearfix rightBoxGap"></div>

    <div class="rightBox1"  *ngIf='currentUrl=="/" || currentUrl=="/data-integration-toolkit-home"'>
      <strong>NEW Toolkit URL with SHA-2 certificate & TSL support- June 5, 2015</strong>
      <p>Connectivity testing starts March 11, 2015. Click here for details and FAQs. For more information,
        contact Toolkit Tech Support or click on the GO.
      </p>
      <a aria-label="Link to New Toolkit URL" target="_blank" [routerLink]="'/locked/new-toolkit-url'"><button aria-label="Link to New Toolkit URL" tabindex=0 role=link class="btn-sm btn-primary rightBoxButton">Go</button></a>

    </div>

  </div>